export default __webpack_public_path__ + "static/media/H4008.1.7c3e9c6e.mp3";